module.exports = __webpack_public_path__ + "static/img/Joseph-O_Neill.983b459.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joseph-O_Neill.jpg
// module id = UoEn
// module chunks = 0